import React, {useEffect, useState} from 'react'
import jwtDecodeAndStore from '../../modules/common/utils/jwtDecodeAndStore'
import {setAccessToken} from '../../modules/common/utils/api'
import Cookies from 'js-cookie'
import {getTrialGuidanceValue} from '../../services/user'

function BambooBanner({bannerType}) {
  const [show, setShow] = React.useState(true)
  const [jwtLoaded, setJwtLoaded] = React.useState(false)
  const [trialValue, setTrialValue] = React.useState('')
  const accessToken = JSON.parse(window.localStorage.getItem('token'))

  const closeBanner = () => {
    setShow(!show)
    bannerType === 'auditBanner'
      ? Cookies.set(accessToken + '_audit_banner', 'yes')
      : Cookies.set(accessToken + '_barcode_banner', 'yes')
  }

  const auditGuidanceBanner = Cookies.get(accessToken + '_audit_banner')
  const BarcodeGuidanceBanner = Cookies.get(accessToken + '_barcode_banner')
  const auditCookie = bannerType === 'auditBanner' && auditGuidanceBanner !== 'yes'
  const barcodeCookie = bannerType === 'barcodeBanner' && BarcodeGuidanceBanner !== 'yes'

  //Decode jwt token on first mount only and store token, then callback update axios instance with auth header
  useEffect(() => {
    if (jwtLoaded) {
      const userDetails = async () => {
        const userId = parseInt(window.localStorage.getItem('user_id'))
        const user = await getTrialGuidanceValue(userId)
        setTrialValue(user)
      }
      userDetails()
    }
  }, [jwtLoaded])

  useEffect(() => {
    jwtDecodeAndStore(() => {
      // setAccessToken will create a "Access-Token" and "Authorization" headers in api request.
      setAccessToken(JSON.parse(window.localStorage.getItem('token')))
      setJwtLoaded(true)
    })
  }, [])

  useEffect(() => {
    setTimeout(function() {
      setShow(!show)
      bannerType === 'auditBanner'
        ? Cookies.set(accessToken + '_audit_banner', 'yes')
        : Cookies.set(accessToken + '_barcode_banner', 'yes')
    }, 8000)
  }, [show, bannerType, accessToken])

  return (
    <div>
      <div
        className={
          trialValue && show && (auditCookie || barcodeCookie) ? 'ds-banner' : 'ds-banner-hide'
        }
      >
        <div className="ds-banner-icon">
          <img alt="icon" src="mobile-icon.svg" />
        </div>
        <div className="ds-banner-title ds-tg800 ds-t100r">
          Did you know that Asset Panda has a mobile app that makes{' '}
          {bannerType === 'auditBanner' ? 'auditing' : 'barcode scanning'} really convenient?
          <br />
          Check it out in the App Store or Google Play today!
        </div>
        <a
          className="ds-banner-link ds-btn-link"
          href={`https://apps.apple.com/us/app/asset-panda/id586542460`}
          target="_blank"
          rel="noreferrer"
        >
          <img alt="icon" src="app-store.svg" />
          App Store
        </a>
        <a
          className="ds-banner-link ds-btn-link"
          href={`https://play.google.com/store/apps/details?id=com.assetpanda&hl=en_US&gl=US`}
          target="_blank"
          rel="noreferrer"
        >
          <img alt="icon" src="google-play.svg" />
          Google Play
        </a>
        <div className="ds-banner-axn">
          <button className="ds-banner-x ds-pill">
            <i className="ds-icon-app-store"></i>
          </button>
          <button className="ds-banner-x ds-pill">
            <i className="ds-icon-google-play"></i>
          </button>
          <button className="ds-banner-x ds-pill" onClick={() => closeBanner()}>
            <i className="ds-icon-close"></i>
          </button>
        </div>
      </div>
    </div>
  )
}

export default BambooBanner
